import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import AuthService from "@/lib/auth";
import StaffUpdateForm from "@/components/admin/StaffUpdateForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2, UserCircle } from "lucide-react";

export default function StaffDetails() {

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [staffData, setStaffData] = useState<any>(null);

  useEffect(() => {
    const fetchStaff = async () => {
      if (!id) return;
      try {
        setLoading(true);
        // Get profile by ID
        const data = await AuthService.getProfile(id);
        setStaffData(data);
      } catch (error) {
        console.error("Error fetching staff details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [id]);

  return (
    <MainLayout>
      <div className="min-h-screen bg-[#f7f8fa] p-6 lg:p-10 font-sans">
        <div className="max-w-4xl mx-auto space-y-6">
          <Button
            variant="ghost"
            onClick={() => navigate("/admin/staff")}
            className="flex items-center gap-2 text-gray-500 hover:text-[#1a7a4a]"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Staff List
          </Button>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#1a7a4a] to-[#2d5a3d] flex items-center justify-center text-white shadow-lg">
                <UserCircle className="h-10 w-10" />
              </div>
              <div>
                <h1 className="text-3xl font-extrabold text-gray-900">
                  Staff Details
                </h1>
                <p className="text-gray-500 font-medium">
                  {loading ? "Loading..." : `Managing profile for ${staffData?.name || staffData?.email}`}
                </p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-col items-center justify-center p-20 space-y-4">
              <Loader2 className="h-12 w-12 animate-spin text-[#1a7a4a]" />
              <p className="text-gray-500 font-semibold animate-pulse">Loading member profile...</p>
            </div>
          ) : staffData ? (
            <StaffUpdateForm staffData={staffData} />
          ) : (
            <div className="bg-white p-10 rounded-3xl text-center border shadow-sm">
              <p className="text-gray-500 text-lg italic">Staff member not found.</p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
}
